export const CUSTOMER_WEB_URL =
  process.env.REACT_APP_CUSTOMER_WEB_URL ??
  (process.env.NODE_ENV === 'development'
    ? 'https://staging-web.getporter.io'
    : 'https://web.getporter.io');
export const DEFAULT_CUSTOMER_SERVICE_FEE = 0.035;
export const DEFAULT_BACKEND_PAYMENTS_RATE = 0.035;
export const DEFAULT_PER_CHARGE_CENTS_FEES = 30;
export const ROUTES = {
  calendar: '/calendar',
  requests: '/requests',
  customers: '/customers',
  shop: '/shop',
  subscription: '/subscription',
  plans: '/plans',
  waivers: '/waivers',
  payments: '/payments',
  team: '/team',
  bookingLinks: '/booking-links',
  marketing: '/marketing',
  chat: '/chat',
  items: '/items',
  import: '/import',
  waiverRequest: '/waiver-request',
  notifications: '/notifications',
  reviews: '/reviews',
  ads: '/ads',
  queue: '/queue',
  cancellationWaitlist: '/cancellation-waitlist',
  reports: '/reports',
  checkouts: '/checkouts',
  capital: '/capital',
  flashbook: '/flashbook',
  bookingSite: '/booking-site',
  getStarted: '/get-started',
  learn: '/learn',
} as const;
export const DEV = process.env.NODE_ENV === 'development';
export const MAX_FILE_SIZE = 25 * 1024 * 1024; // 25MB

export const FILTER_PERSISTENCE_KEYS = {
  calendarArtists: 'calendar-artists',
  customerArtists: 'customer-artists',
  calendarEvents: 'calendar-events',
  calendarWaiverStatus: 'calendar-waiver-status',
  calendarDepositStatus: 'calendar-deposit-status',
  calendarTrips: 'calendar-trips',
  calendarInactiveEmployees: 'calendar-inactive-employees',
} as const;

export const SUPPORT_URL = 'https://support.getporter.io/';

export const GET_STARTED_URL = 'https://www.getporter.io/get-started';

export const PRODUCT_UPDATES_URL =
  'https://www.instagram.com/channel/AbYbXqA9NtQUX490/';
